import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { TextField, Button, MenuItem } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB";
import { Get_All_From_MongoDB } from "../../../../api/Get_All_From_MongoDB";
import { Request_Get_Agencies_Fuzzy_Search } from "../../api/Request_Get_Agencies_Fuzzy_Search";
import { Request_Get_ECs_Fuzzy_Search } from "../../api/Request_Get_ECs_Fuzzy_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SearchBar({ setECs }) {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Staff---------------------------------------------
  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB(
      "Staff",
      "Users",
      100,
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  const [limit, setlimit] = useState(20);

  //Filter the staff for IP's
  let IPStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("ip".toLowerCase())
  );

  //The below gets the Agencies
  const [Agencies, setAgencies] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("IP", "Agencies", setAgencies, logout);
  }, []);

  //Table Search
  const [searchName, setSearchName] = useState("");
  const [searchStaffID, setSearchStaffID] = useState("");
  const handleSearchName = (event) => {
    setSearchName(event.target.value);
  };

  const handleSearchStaffID = (event) => {
    setSearchStaffID(event.target.value);
  };

  const handleChangeLimit = (event) => {
    setlimit(event.target.value);
  };

  //Need to get all ID's for agencies who have the IP member
  let AllAgencyIDsForChosenIPMember = Agencies.filter(
    (Agency) => !searchStaffID || Agency.MetaData.IP_id === searchStaffID
  ).map((Agency) => Agency._id);

  function handleSubmit(e) {
    e.preventDefault();
    Request_Get_ECs_Fuzzy_Search(
      "IP",
      "EC",
      searchName,
      AllAgencyIDsForChosenIPMember,
      Number(limit),
      setECs,
      logout
    );
  }

  function handleLoadAll(e) {
    e.preventDefault();
    Request_Get_ECs_Fuzzy_Search("IP", "EC", "", "", 100000, setECs, logout);
  }

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "35%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Search Bar
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Change to row to align items in a line
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically
          gap: "5px",
          color: "black",
          padding: "5px",
          width: "100%",
        }}
      >
        <TextField
          id="search_name"
          label="Name"
          variant="outlined"
          value={searchName}
          onChange={handleSearchName}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />

        <TextField
          required
          select
          id="search_StaffID"
          label="Staff"
          value={searchStaffID}
          onChange={handleSearchStaffID}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        >
          <MenuItem value="">---None---</MenuItem>
          {IPStaff.map((prop) => (
            <MenuItem value={prop._id}>{prop.Username}</MenuItem>
          ))}
        </TextField>
        <TextField
          id="search_StaffID"
          label="ID"
          variant="outlined"
          value={searchStaffID}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
          disabled
        />
        <TextField
          id="limit"
          label="Limit"
          variant="outlined"
          value={limit}
          onChange={handleChangeLimit}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
          type="number"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Change to row to align items in a line
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically
          gap: "5px",
          color: "black",
          padding: "5px",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none", width: "48%" }}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none", width: "48%" }}
          onClick={(e) => {
            handleLoadAll(e);
          }}
        >
          Load All
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBar;
